module.exports = __webpack_public_path__ + "media/images/vyuctovani-f994103005cbb427a07b5b46e075f75b.png";